export default __webpack_public_path__ + "static/mapping_video-47e71dc3106d6da82392e96251900cdf.mp4";